import { useFlag } from '@unleash/proxy-client-react';
import { FeatureFlag, getEnvFeatureFlag } from '~/utils/feature-flags-utils';

export const useFeatureFlag = (flag: FeatureFlag) => {
    const featureFlag = getEnvFeatureFlag(flag);
    return useFlag(featureFlag);
};
